import React, { useEffect } from "react";
import { useState, useLayoutEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Flex,
  Text,
  Button,
  Heading,
  Badge,
  Icon,
  Image,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Tooltip,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FaCircleInfo } from "react-icons/fa6";
import {
  primary,
  primaryAlt,
  textPrimary,
  textSecondary,
  backgroundLight,
  newBorder,
  color8,
  white,
  hoverItemColor,
} from "../../../../../utils/colors";
import { useTranslation } from "react-i18next";
import { FaCaretDown, FaXmark } from "react-icons/fa6";
import { useSelector, useDispatch } from "react-redux";
import { getGlobalModulesAction } from "../../../../../actions/paymentActions";
// import { useCurrencyPricing } from "../../../../../hooks/useCurrencyPricing";
import { convertFromUSD } from "../../../../../utils/currency";
import {
  TbCash,
  TbMail,
  TbMessage,
  TbSettings,
  TbUser,
  TbUsers,
} from "react-icons/tb";
import { shade, tint } from "polished";

const CheckoutPlans = ({
  tenant,
  slug,
  selectedSubscrition,
  setSelectedSubscription,
  selectedStripePriceId,
  setSelectedStripePriceId,
  setCheckoutPanelOpen,
  selectedPlan,
  setSelectedPlan,
  monthly,
  setMonthly,
  currentCurrency,
  setCurrentCurrency,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currencies = ["USD", "EUR", "GBP"];

  // const [currentCurrency, setCurrentCurrency] = useState("EUR");
  const [currentTenantPlanKey, setCurrentTenantPlanKey] = useState(null);

  const [plans, setPlans] = useState([]);

  const getCurrencySymbol = (code) => {
    const map = {
      EUR: "€",
      USD: "$",
      GBP: "£",
    };
    return map[code] || code;
  };

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const closeHandler = () => {
    setCheckoutPanelOpen(false);
    setSelectedStripePriceId(null);
    setSelectedSubscription(null);
    setSelectedPlan(null);
  };

  // REDUX
  const paymentTenantGetModules = useSelector(
    (state) => state.paymentTenantGetModules
  );
  const {
    loading: loadingModules,
    error: errorModules,
    success: successModules,
    modules,
  } = paymentTenantGetModules;

  // USE EFFECT
  useEffect(() => {
    dispatch(getGlobalModulesAction(slug));
  }, [dispatch, slug]);

  useEffect(() => {
    if (tenant && tenant.currency) {
      setCurrentCurrency(tenant.currency);
    }
  }, [tenant]);

  useEffect(() => {
    if (modules && modules.length > 0) {
      console.log("name", selectedSubscrition.name);
      console.log("module name", modules[0].name);

      const normalize = (str) => str?.toLowerCase().replaceAll(" ", "-");

      const selectedModule = modules.find(
        (module) =>
          normalize(module.name) === normalize(selectedSubscrition.name)
      );
      if (selectedModule) {
        const selectedPlans = selectedModule.plans.map((plan) => ({
          ...plan,
          title: t(
            `module.plan-${normalize(selectedSubscrition.name)}-${
              plan.key
            }-title`
          ),
          subtitle: t(
            `module.plan-${normalize(selectedSubscrition.name)}-${
              plan.key
            }-description`
          ),
          limitPlansText: t(
            `module.plan-${normalize(selectedSubscrition.name)}-${
              plan.key
            }-limit`
          ),
          buttonColor: plan.isMostPopular ? primaryAlt : textPrimary,
          priceUsdMonthly: (plan.priceUsdMonthly / 100).toFixed(0),
          priceUsdAnnual: (plan.priceUsdAnnual / 100).toFixed(0),
          priceUsdAnnualMonthly: (plan.priceUsdAnnualMonthly / 100).toFixed(0),
          stripePriceId: monthly
            ? plan.stripePriceIdMonthly
            : plan.stripePriceIdAnnual,
        }));

        setPlans(selectedPlans);
      }
    }
  }, [modules, selectedSubscrition, t]);

  useEffect(() => {
    if (tenant?.subscriptions && selectedSubscrition?.name) {
      const subscription = tenant.subscriptions.find(
        (sub) =>
          sub.name === selectedSubscrition.name && sub.status === "active"
      );

      if (subscription) {
        setCurrentTenantPlanKey(subscription.plan); // e.g., 'free', 'premium'
      }
    }
  }, [tenant, selectedSubscrition]);

  // CUSTOM

  const getConvertedPrice = (usdValue) =>
    convertFromUSD(usdValue, currentCurrency);

  // LOG

  // console.log("currentCurrency", currentCurrency);
  // console.log("selectedStripePriceId", selectedStripePriceId);
  console.log("modules", modules);
  console.log("plans", plans);
  console.log("currentTenantPlanKey", currentTenantPlanKey);

  // console.log("selectedPlan", selectedPlan);
  // console.log("monthly", monthly);

  console.log("tenant.subscriptions", tenant?.subscriptions);

  return (
    <>
      <Flex align="center" justify="space-between" p="2rem 0rem">
        <Heading fontSize="1.25rem" fontWeight="600">
          {t(`module.${selectedSubscrition?.name}`)} {t("module.subscription")}
        </Heading>
        <IconButton
          position="relative"
          // top="1.5rem"
          // right="1.5rem"
          size="sm"
          bg={backgroundLight}
          color={textSecondary}
          onClick={closeHandler}
          borderRadius="10rem"
          _hover={{ bg: primaryAlt, color: white }}
        >
          <Icon as={FaXmark} />
        </IconButton>
      </Flex>

      <Box
        as={motion.div}
        w="100%"
        h="100%"
        exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
        initial={{ opacity: 0, x: 0, y: 0 }}
        animate={{
          opacity: 1,
          x: 0,
          y: 0,
          transition: { duration: 0.15 },
          // transition: { delay: 0.3, duration: 0.2 },
        }}
      >
        <Flex w="100%" maxW="1000px" m="0 auto" p="0rem 0 0">
          <Flex direction="column" w="100%">
            {/* MAIN START*/}
            <Flex w="100%" maxW="1000px" m="0rem auto 0" direction="column">
              {/* BUTTON START */}
              <Flex align="flex-end" justify="space-between" m="0 0 1.5rem">
                <Flex align="center">
                  <Flex
                    align="center"
                    bg={backgroundLight}
                    borderRadius="10rem"
                    p="0.5rem"
                  >
                    <Button
                      bg={monthly ? primaryAlt : backgroundLight}
                      color={monthly ? white : textSecondary}
                      fontWeight="500"
                      size="md"
                      fontSize="sm"
                      borderRadius="10rem"
                      onClick={() => setMonthly(true)}
                      _hover={{
                        bg: monthly ? primaryAlt : "transparent",
                        color: monthly ? white : textPrimary,
                      }}
                    >
                      {t("module.pricingMonthly")}{" "}
                    </Button>
                    <Button
                      bg={monthly ? backgroundLight : primaryAlt}
                      color={monthly ? textSecondary : white}
                      fontWeight="500"
                      size="md"
                      fontSize="sm"
                      borderRadius="10rem"
                      onClick={() => setMonthly(false)}
                      role="group"
                      _hover={{
                        bg: monthly ? "transparent" : primaryAlt,
                        color: monthly ? textPrimary : white,
                      }}
                    >
                      {t("module.pricingYearly")}{" "}
                      <span>
                        <Text
                          fontSize="sm"
                          ml={1}
                          color={monthly ? primary : white}
                          _groupHover={{
                            color: monthly ? primaryAlt : white,
                          }}
                        >
                          {t("module.saveYearly")}{" "}
                        </Text>
                      </span>
                    </Button>
                  </Flex>
                  {!monthly && (
                    <Flex align="center" ml="0.5rem">
                      <Text
                        fontSize="sm"
                        color={primaryAlt}
                        m="0rem 0 0"
                        fontWeight="500"
                      >
                        {t("module.pricingMonthsFree")}{" "}
                      </Text>
                    </Flex>
                  )}
                </Flex>

                <Flex align="flex-end">
                  <Box>
                    <Menu>
                      <Flex align="center">
                        <MenuButton
                          as={Button}
                          size="sm"
                          variant="outline"
                          borderRadius="10rem"
                          fontWeight="500"
                          color={textPrimary}
                          border={`0px solid ${newBorder}`}
                          bg={backgroundLight}
                          // leftIcon={<FaDollarSign />}
                          role="group"
                          _hover={{
                            bg: primaryAlt,
                            color: white,
                          }}
                        >
                          {getCurrencySymbol(currentCurrency)} {currentCurrency}
                          <Icon
                            as={FaCaretDown}
                            fontSize="0rem"
                            position="relative"
                            top="1px"
                            ml="0rem"
                            transition="all 0.2s ease"
                            _groupHover={{
                              ml: "0.25rem",
                              fontSize: "0.75rem",
                            }}
                          />
                        </MenuButton>
                        <Tooltip
                          p="0.5rem 1rem"
                          borderRadius="1rem"
                          fontSize="0.8rem"
                          placement="top"
                          label={<>{t("module.currencyTooltipText")}</>}
                        >
                          <span>
                            <Icon
                              as={FaCircleInfo}
                              ml={2}
                              fontSize="0.875rem"
                              color={primaryAlt}
                            />
                          </span>
                        </Tooltip>
                      </Flex>
                      <MenuList
                        zIndex={9999}
                        p="0"
                        borderRadius="1rem"
                        overflow="hidden"
                      >
                        {currencies.map((cur) => (
                          <MenuItem
                            bg={cur === currentCurrency ? primaryAlt : white}
                            key={cur}
                            fontSize="sm"
                            p="0.75rem 1rem"
                            onClick={() => setCurrentCurrency(cur)}
                            fontWeight={cur === currentCurrency ? "500" : "500"}
                            color={
                              cur === currentCurrency ? white : textSecondary
                            }
                            _hover={{
                              bg:
                                cur === currentCurrency
                                  ? primaryAlt
                                  : hoverItemColor,
                              color:
                                cur === currentCurrency ? white : textPrimary,
                            }}
                          >
                            {getCurrencySymbol(cur)} {cur}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </Menu>

                    {/* <ButtonGroup isAttached size="sm" variant="outline">
                      {currencies.map((cur) => (
                        <Button
                          key={cur}
                          onClick={() => setCurrentCurrency(cur)}
                          colorScheme={
                            cur === currentCurrency ? "purple" : "gray"
                          }
                          variant={
                            cur === currentCurrency ? "solid" : "outline"
                          }
                          fontWeight="500"
                          borderRadius="10rem"
                        >
                          {cur}
                        </Button>
                      ))}
                    </ButtonGroup> */}
                  </Box>
                </Flex>
              </Flex>
              {/* BUTTONS END */}
              {/* PLANS START */}
              <Flex
                border={`1px solid ${newBorder}`}
                w="100%"
                borderRadius="1.75rem"
              >
                {plans.map((plan, index) => (
                  <Box
                    key={index}
                    flex="1"
                    minW="33.33%"
                    w="33.33%"
                    p="2.5rem 2rem"
                    // h="380px"
                    textAlign="left"
                    bg={plan.isMostPopular ? "purple.50" : "transparent"}
                  >
                    <Flex align="center" justify="space-between">
                      <Heading
                        fontSize="1.25rem"
                        fontWeight="600"
                        h="26px"
                        color={textPrimary}
                      >
                        {t(
                          `module.plan-${selectedSubscrition.name}-${plan.key}-title`
                        )}{" "}
                        {/* {plan.title} */}
                      </Heading>
                      {plan.isMostPopular && (
                        <Badge
                          p="0.25rem 1rem"
                          borderRadius="10rem"
                          bg={color8}
                          color={textPrimary}
                          fontWeight="500"
                          variant="solid"
                        >
                          {t("module.pricingMostPopular")}
                        </Badge>
                      )}
                    </Flex>

                    <Flex
                      direction="column"
                      gap="0.25rem"
                      m="1.5rem 0"
                      h="34px"
                      // minH="4rem"
                    >
                      <Flex align="baseline" gap="0.5rem">
                        {!monthly && plan.key !== "free" && (
                          <Text
                            fontSize="lg"
                            fontWeight="500"
                            color="gray.500"
                            textDecoration="line-through"
                          >
                            {getCurrencySymbol(currentCurrency)}{" "}
                            {getConvertedPrice(plan.priceUsdMonthly)}
                          </Text>
                        )}

                        <Text
                          fontSize="2rem"
                          fontWeight="600"
                          lineHeight="1"
                          color={textPrimary}
                        >
                          {getCurrencySymbol(currentCurrency)}{" "}
                          {!monthly
                            ? getConvertedPrice(plan.priceUsdAnnualMonthly)
                            : getConvertedPrice(plan.priceUsdMonthly)}
                        </Text>
                        <Text
                          fontSize="0.8rem"
                          fontWeight="500"
                          color={textSecondary}
                        >
                          {t("module.pricingPerMonth")}
                        </Text>
                      </Flex>

                      {!monthly && (
                        <Flex align="center">
                          <Text
                            fontSize="0.8rem"
                            color={textSecondary}
                            h="13px"
                            m="0rem 0 0"
                            fontWeight="500"
                          >
                            {plan.key !== "free" && (
                              <>
                                <Text as="span" mr={1}>
                                  {t("module.pricingBilledAnnually")}
                                </Text>
                                {getCurrencySymbol(currentCurrency)}{" "}
                                {getConvertedPrice(plan.priceUsdAnnual)}
                              </>
                            )}
                          </Text>
                        </Flex>
                      )}
                    </Flex>

                    {/* PRICE END */}
                    {/* <Text fontSize="md" fontWeight="500" color={textSecondary}>
                      {plan.subtitle}
                    </Text> */}

                    <Flex
                      align="center"
                      justify="flex-start"
                      m={monthly ? "1.5rem 0 0" : "2.5rem 0 0"}
                      transition="all 0.2s ease"
                      fontSize="sm"
                      fontWeight="500"
                      color={textSecondary}
                      gap="0.5rem"
                      textAlign="left"
                    >
                      <Flex align="center">
                        <Text fontWeight="500">
                          {t(
                            `module.plan-${selectedSubscrition.name}-${plan.key}-description`
                          )}
                        </Text>
                      </Flex>
                    </Flex>

                    <Flex
                      direction="column"
                      gap="0.75rem"
                      m="1.5rem 0 0"
                      borderTop={`1px solid ${newBorder}`}
                      pt="1.25rem"
                    >
                      {/* PLAN LIMITS START */}
                      <Flex
                        align="center"
                        justify="space-between"
                        fontSize="sm"
                        fontWeight="500"
                        color={textSecondary}
                        gap="0.5rem"
                        textAlign="left"
                      >
                        <Flex align="center">
                          <Image
                            src="/icons/treatment.svg"
                            opacity="0.6"
                            h="1rem"
                            position="relative"
                            top="-1px"
                            mr={1}
                          />

                          <Text fontWeight="500">
                            {plan.key !== "enterprise" ? (
                              <Text
                                as="span"
                                fontWeight="600"
                                color={textPrimary}
                                mr={1}
                              >
                                {plan.limitCount}
                              </Text>
                            ) : (
                              <Text
                                as="span"
                                fontWeight="600"
                                color={textPrimary}
                                mr={1}
                              >
                                &#8734;
                              </Text>
                            )}
                            {t(
                              `module.plan-${selectedSubscrition.name}-${plan.key}-limit`,
                              {
                                limit: plan.limitCount,
                              }
                            )}
                          </Text>
                        </Flex>
                      </Flex>
                      {/* PLAN LIMITS END */}

                      {/* SECOND FEATURE START */}
                      <Flex
                        align="center"
                        justify="space-between"
                        fontSize="sm"
                        fontWeight="500"
                        color={textSecondary}
                        gap="0.5rem"
                        textAlign="left"
                      >
                        <Flex align="center">
                          <Icon
                            as={
                              plan.key === "enterprise"
                                ? TbUser
                                : plan.key === "premium"
                                ? TbUsers
                                : TbMail
                            }
                            color={textSecondary}
                            ml={0.5}
                            mr={1}
                          />

                          <Text fontWeight="500">
                            {plan.key === "free"
                              ? t("module.fixedLimitFree")
                              : plan.key === "premium"
                              ? t("module.fixedLimitPremium")
                              : t("module.fixedLimitEnterprise")}
                          </Text>
                        </Flex>
                      </Flex>
                      {/* SECOND FEATURE END */}

                      {/* THIRD FEATURE START */}

                      <Flex
                        align="center"
                        justify="space-between"
                        fontSize="sm"
                        fontWeight="500"
                        color={textSecondary}
                        gap="0.5rem"
                        textAlign="left"
                      >
                        <Flex align="center">
                          <Icon
                            as={
                              plan.key === "enterprise"
                                ? TbSettings
                                : plan.key === "premium"
                                ? TbMessage
                                : TbCash
                            }
                            color={textSecondary}
                            ml={0.5}
                            mr={1}
                          />

                          <Text fontWeight="500">
                            {plan.key === "free"
                              ? t("module.limitTextFree")
                              : plan.key === "premium"
                              ? t("module.limitTextPremium")
                              : t("module.limitTextEnterprise")}
                          </Text>
                        </Flex>
                      </Flex>
                      {/* THIRD FEATURE END */}
                    </Flex>

                    <Button
                      bg={plan.buttonColor}
                      m="2rem 0 0"
                      color="white"
                      fontWeight="500"
                      size="lg"
                      fontSize="md"
                      w="100%"
                      borderRadius="10rem"
                      //   onClick={() => navigate("/register")}
                      onClick={() => {
                        setSelectedPlan(plan);
                        setMonthly(monthly);
                      }}
                      isDisabled={currentTenantPlanKey === plan.key}
                      _hover={{
                        bg: shade(0.2, plan.buttonColor),
                      }}
                    >
                      {currentTenantPlanKey === plan.key
                        ? t("module.currentPlan")
                        : t("module.pricingGetStarted")}
                    </Button>

                    {/* LIMITS INFO START */}
                    {/* <Flex
                      align="flex-start"
                      justify="flex-start"
                      direction="column"
                      m="1.5rem 0 0"
                      fontSize="sm"
                      fontWeight="500"
                      color={textSecondary}
                      gap="0.5rem"
                      textAlign="left"
                    >
                      <Flex align="center">
                        <Icon
                          as={FaCheck}
                          color={textSecondary}
                          fontSize="0.75rem"
                          mr="0.5rem"
                        />
                        <Text>{t("module.unlimitedUsers")}</Text>
                      </Flex>
                      <Flex align="center">
                        <Icon
                          as={FaCheck}
                          color={textSecondary}
                          fontSize="0.75rem"
                          mr="0.5rem"
                        />
                        <Text>{t("module.patientImport")}</Text>
                      </Flex>
                      <Flex align="center">
                        <Icon
                          as={FaCheck}
                          color={textSecondary}
                          fontSize="0.75rem"
                          mr="0.5rem"
                        />
                        <Text>{t("module.senderIdentities")}</Text>
                      </Flex>
                    </Flex> */}
                  </Box>
                ))}
              </Flex>
              {/* PLANS END */}

              <Flex w="100%" align="center" justify="center" mt="1.5rem">
                <Flex align="center">
                  <Text
                    fontSize="sm"
                    color={textSecondary}
                    textAlign="center"
                    maxW="600px"
                  >
                    {t("module.pricingNotSure")}
                  </Text>
                  <Link
                    target="_blank"
                    to="https://www.dentacasa.com/en/pricing"
                  >
                    <Text
                      fontSize="sm"
                      color={primary}
                      textAlign="center"
                      ml={1}
                      fontWeight="500"
                      _hover={{
                        color: primaryAlt,
                      }}
                    >
                      {t("module.viewPlanComparison")}
                    </Text>
                  </Link>
                </Flex>
              </Flex>
            </Flex>
            {/* MAIN END */}
          </Flex>
        </Flex>
      </Box>
    </>
  );
};

export default CheckoutPlans;
